import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import { ReferralProgram } from "../types/view.referral";
import { fallback } from "../utils/formatters";
import { AddCircleOutlineOutlined } from "@mui/icons-material";

interface Props {
  data: ReferralProgram;
}

export default function DocumentsCard({ data }: Props) {
  const documents = data.documents ?? [];

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "24px",
        p: 2.5,
        backgroundColor: "#fff",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
          Documents
        </Typography>

        <IconButton size="small">
          <AddCircleOutlineOutlined fontSize="small" />
        </IconButton>
      </Box>

      {documents.length === 0 ? (
        <Box
          sx={{
            borderRadius: "16px",
            p: 3,
            color: "#8A94A6",
            textAlign: "center",
          }}
        >
          No documents available at the moment
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {documents.map((doc) => (
            <Box
              key={doc.id}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid #F0F2F6",
                borderRadius: "14px",
                px: 1.5,
                py: 1.2,
                backgroundColor: "#FCFCFD",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                <PictureAsPdfIcon sx={{ color: "#E85C57" }} />
                <Box>
                  <Typography sx={{ fontSize: "0.95rem", color: "#4A5568" }}>
                    {fallback(doc.name)}
                  </Typography>
                  <Typography sx={{ fontSize: "0.8rem", color: "#A0AEC0" }}>
                    {fallback(doc.size)}
                  </Typography>
                </Box>
              </Box>

              <Box>
                <IconButton size="small" disabled={!doc.url}>
                  <DownloadIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" disabled>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
}
